import React from "react";
import { FormControlLabel, Switch } from "@mui/material";
import { withStyles } from "@mui/styles";

const CustomSwitch = withStyles({
  switchBase: {
    color: "white",
    "&$checked": {
      color: "white",
    },
    "&$checked + $track": {
      backgroundColor: "#FFD700",
    },
  },
  checked: {},
  track: {},
})(Switch);

function SwitchButton(props) {
  let { label, disabled, checked, onChange } = props;
  return (
    <FormControlLabel
      disabled={disabled}
      checked={checked}
      control={<CustomSwitch />}
      label={
        <p
          className={`${
            disabled ? "text-[#A7A7A7]" : "text-[#3A3A3A]"
          } font-normal text-[1rem]`}
        >
          {label}
        </p>
      }
      onChange={onChange}
    />
  );
}

export default SwitchButton;
